import { format, formatDistanceToNow } from "date-fns";
import {
  Sparkles, Clock, CheckCircle, XCircle, Calendar, LogIn, Receipt, AlertTriangle,
} from "lucide-react";

const KIND_META = {
  signup:       { icon: Sparkles,   color: "text-blue-300",   bg: "bg-blue-500/15" },
  trial_end:    { icon: Clock,      color: "text-yellow-300", bg: "bg-yellow-500/15" },
  first_paid:   { icon: CheckCircle,color: "text-emerald-300",bg: "bg-emerald-500/15" },
  last_paid:    { icon: Receipt,    color: "text-emerald-200",bg: "bg-emerald-500/10" },
  sub_end:      { icon: XCircle,    color: "text-red-300",    bg: "bg-red-500/15" },
  first_event:  { icon: Calendar,   color: "text-purple-300", bg: "bg-purple-500/15" },
  last_event:   { icon: Calendar,   color: "text-purple-200", bg: "bg-purple-500/10" },
  last_login:   { icon: LogIn,      color: "text-cyan-300",   bg: "bg-cyan-500/15" },
};

const fmtAbs = (iso) => { try { return iso ? format(new Date(iso), "MMM d, yyyy") : "—"; } catch { return iso; } };
const fmtRel = (iso) => { try { return iso ? formatDistanceToNow(new Date(iso), { addSuffix: true }) : ""; } catch { return ""; } };

export default function ActivityTimeline({ entries = [] }) {
  if (!entries.length) {
    return (
      <div className="py-6 text-center text-sm text-muted-foreground">
        <AlertTriangle className="w-5 h-5 mx-auto mb-2 opacity-60" />
        No timeline events yet — band may have just been created.
      </div>
    );
  }
  return (
    <div className="relative pl-3" data-testid="activity-timeline">
      <div className="absolute left-[10px] top-1 bottom-1 w-px bg-white/10" />
      <ul className="space-y-3">
        {entries.map((e, i) => {
          const meta = KIND_META[e.kind] || { icon: Sparkles, color: "text-muted-foreground", bg: "bg-white/5" };
          const Icon = meta.icon;
          return (
            <li key={`${e.at}-${i}`} className="relative pl-7" data-testid={`timeline-${e.kind}`}>
              <span className={`absolute left-[3px] top-1 w-[14px] h-[14px] rounded-full ${meta.bg} ring-1 ring-white/10 flex items-center justify-center`}>
                <Icon className={`w-2.5 h-2.5 ${meta.color}`} />
              </span>
              <div className="flex flex-wrap items-baseline gap-x-2">
                <span className={`text-sm font-medium ${meta.color}`}>{e.label}</span>
                <span className="text-xs text-muted-foreground">{fmtAbs(e.at)}</span>
                <span className="text-[11px] text-muted-foreground/70">{fmtRel(e.at)}</span>
              </div>
              {e.detail && <div className="text-xs text-muted-foreground mt-0.5 break-words">{e.detail}</div>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
